module.exports = __webpack_public_path__ + "static/media/wolffox4_preview.52412d9f.jpg";